import {atom} from 'recoil';

export const accountDataStateRefresher = atom({
	key: 'accountDataStateRefresher',
	default: 0,
});

export const refresherState = atom({
	key: 'forcedRefresh',
	default: 0,
});
